exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-205819be], .fade-leave-active[data-v-205819be] {\n    -webkit-transition: opacity .3s;\n    transition: opacity .3s;\n}\n.fade-enter[data-v-205819be], .fade-leave-to[data-v-205819be] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\n", ""]);

// exports
